/**
 * Selected lander tags as removable chips.
 * For Media Devoted | Created By Ciro Autiero
 */

import { X } from 'lucide-react';

import type { FC } from 'react';

export interface LanderSelectedTagChipsProps {
  tags: string[];
  disabled?: boolean;
  onRemove: (tag: string) => void;
}

const LanderSelectedTagChips: FC<LanderSelectedTagChipsProps> = ({
  tags,
  disabled,
  onRemove,
}) => (
  <div className="flex min-h-8 flex-wrap gap-1.5">
    {tags.map((tag) => (
      <span
        key={tag}
        className="inline-flex max-w-full items-center gap-1 rounded-md border border-border bg-muted/60 px-2 py-0.5 text-xs font-medium text-foreground"
      >
        <span className="truncate">{tag}</span>
        <button
          type="button"
          className="shrink-0 rounded p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
          onClick={() => onRemove(tag)}
          disabled={disabled}
          aria-label={`Remove tag ${tag}`}
        >
          <X className="h-3 w-3" aria-hidden />
        </button>
      </span>
    ))}
  </div>
);

export default LanderSelectedTagChips;
